import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import { PlusIcon, LightningBoltIcon } from "@radix-ui/react-icons";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "@/components/ui/dropdown-menu";
import { SparklesIcon } from "@heroicons/react/24/solid";
import { useTranslation } from "react-i18next";

interface CreateTenderButtonProps {
  handleOpenExperimentalFeatureModal: () => void;
}

function CreateTenderButton({ handleOpenExperimentalFeatureModal }: CreateTenderButtonProps) {
  const { t } = useTranslation(["components"]);

  const isInNewTender = location.pathname.includes("tender/new");

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant={`${isInNewTender ? "outline" : "default"}`} data-cy="create-tender-dropdown">
          {t("header.newtender")}
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent className="flex flex-col gap-2">
        <Link to="/tender/new">
          <DropdownMenuItem className="hover:cursor-pointer" data-cy="create-new-tender">
            <PlusIcon className="mr-2" />
            {t("header.createtender.btncreatenewtender")}
          </DropdownMenuItem>
        </Link>
        <Link to="/tender/newquickchance">
          <DropdownMenuItem className="hover:cursor-pointer" data-cy="create-quick-tender">
            <LightningBoltIcon className="mr-2" />
            {t("header.createtender.btncreatenewquicktender")}
          </DropdownMenuItem>
        </Link>
        <DropdownMenuItem
          onClick={handleOpenExperimentalFeatureModal}
          className="hover:cursor-pointer text-blue-500"
          data-cy="ai-import-option"
        >
          <SparklesIcon className="mr-2 w-[15px] h-[15px]" />
          {t("header.createtender.btnaiimport")}
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}

export default CreateTenderButton;
